import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

import { getFullName } from '@utils';
import {
  CATEGORY_TYPES_ORDER,
  BOOKINGS_TYPE,
  ORDERS_TYPE,
  SUBSCRIPTIONS_TYPE,
} from './constants';

const getUnKnownResultType = (type) => ({
  label: type,
  icon: QuestionMarkIcon,
  testid: 'QuestionMarkIcon',
});

const getTextToHighlight = (type, option) => {
  if (type === SUBSCRIPTIONS_TYPE) {
    return `${[
      getFullName(option),
      `${option?.brand || ''} ${option?.model || ''}`.trim() || '',
      option?.plate,
    ]
      .filter(Boolean)
      .join(' - ')}`;
  }

  return (
    ((type === BOOKINGS_TYPE || type === ORDERS_TYPE) && option?.objectID) ||
    (option?.name && `${option?.name}`) ||
    (option?.firstName && `${option?.firstName} ${option?.lastName}`) ||
    (option?.brand && `${option?.brand} ${option?.model}`) ||
    '-'
  );
};

const getMissingTypeCategories = (options) => {
  const existingTypes = new Set(options.map((opt) => opt.type));

  const missingCategories = CATEGORY_TYPES_ORDER.filter(
    (type) => !existingTypes.has(type)
  );

  return missingCategories;
};

const reorderCategoryTypes = (originalObjectOptions, categoryTypesOrder) => {
  const orderedObject = {};

  categoryTypesOrder.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(originalObjectOptions, key)) {
      orderedObject[key] = originalObjectOptions[key];
    }
  });
  return orderedObject;
};

export {
  getUnKnownResultType,
  getTextToHighlight,
  getMissingTypeCategories,
  reorderCategoryTypes,
};
